<template>
  <card-wrapper title="Ogłoszenia" class="card-wrapper">
    <loader :state="actions.messages" without-loading>
      <div class="columns">
        <div class="column is-4 is-3-widescreen is-offset-1-desktop">
          <messages-list
            class="messages-list"
            :messages="messages"
            :current="current"
            :page="pageable.page"
            @click-message="selectMessage"
          />
          <pagination
            class="is-small is-centered"
            v-if="pageable"
            :delta="1"
            :pageable="pageable"
            @change-page="changePage"
            light
          />
        </div>
        <div class="column is-8-tablet is-6-desktop is-7-widescreen">
          <div class="message-wrapper">
            <transition name="slide-top-down" mode="out-in">
              <message :message="current" v-if="current" :key="current.id" />
              <div
                class="message-placeholder is-hidden-mobile is-unselectable"
                v-else
                key="message-placeholder"
              >
                <img
                  class="message-placeholder__img"
                  src="../assets/img/mailbox.svg"
                />
              </div>
            </transition>
          </div>
        </div>
      </div>

      <template #error>
        <div class="error-message is-unselectable">
          <img src="../assets/img/no-data.svg" />
          <p>Ogłoszenia niedostępe ze względu na brak połączenia z serwerem</p>
        </div>
      </template>
    </loader>
  </card-wrapper>
</template>

<script>
import { mapState, mapGetters } from "vuex";

import { CLEAR_CURRENT_MESSAGE } from ":mutations";
import { REQUEST_MESSAGES, REQUEST_MESSAGE } from ":actions";

import { CardWrapper, Pagination } from "%helpers";

import { WithDispatcherProgress } from "%mixins";
import MessagesList from "%components/messages/MessagesList";
import Message from "%components/messages/Message";

const PAGE_SIZE = 4;

export default {
  name: "messages",

  components: {
    CardWrapper,
    Pagination,
    MessagesList,
    Message
  },

  mixins: [WithDispatcherProgress],

  props: {
    messageId: Number
  },

  computed: {
    ...mapGetters(["messages"]),

    ...mapState({
      pageable: state => state.messages.pageable,
      current: state => state.messages.current
    })
  },

  methods: {
    scrollToMessage() {
      this.$scrollTo(".message-wrapper", 500, {
        offset: -100
      });
    },

    scrollToList() {
      this.$scrollTo(".messages-list", 500, {
        offset: -100
      });
    },

    selectMessage(message) {
      this.$router.push(`/messages/${message.id}`);
    },

    async loadMessage() {
      if (this.messageId) {
        await this.dispatchWithProgress("message", REQUEST_MESSAGE, {
          id: this.messageId
        });
        this.scrollToMessage();
      }
    },

    async changePage(page) {
      await this.requestMessagesPage(page);
      this.scrollToList();
    },

    async requestMessagesPage(page) {
      await this.dispatchWithProgress("messages", REQUEST_MESSAGES, {
        page,
        size: PAGE_SIZE
      });
    }
  },

  mounted() {
    this.requestMessagesPage(1);
    this.loadMessage();
  },

  beforeDestroy() {
    this.$store.commit(CLEAR_CURRENT_MESSAGE);
  },

  watch: {
    messageId() {
      this.loadMessage();
    }
  }
};
</script>

<style lang="scss" scoped>
.card-wrapper {
  min-height: 150vh;
  justify-content: flex-start;

  .message-placeholder {
    text-align: center;

    &__img {
      width: 50%;
    }
  }
}

.error-message {
  padding: 1rem;
  color: $white;
  font-size: 1.5rem;
  text-align: center;

  img {
    @include mobile {
      width: 50%;
    }

    @include until($small-mobile) {
      width: 70%;
    }

    @include tablet {
      width: 40%;
    }

    @include desktop {
      width: 25%;
    }
  }
}
</style>
